import React, { useEffect, useState } from "react";
import { Label, Input, FormFeedback, Col, Row } from "reactstrap";
import Flatpickr from "react-flatpickr";
import { useSelector, useDispatch } from "react-redux";
import * as moment from "moment";
import { getClients as onGetClients } from "../../../slices/thunks";

const ContractTab = ({ formik, clientDetails }) => {
  const dispatch = useDispatch();
  const { clients } = useSelector((state) => {
    return state.Clients;
  });

  useEffect(() => {
    if (!clients || clients.length === 0) {
      dispatch(onGetClients());
    }
  }, [clients, dispatch]);

  return (
    <div style={{ padding: "0px 100px" }}>
      <Row>
        <Col>
          <div className="mb-3">
            <Label htmlFor="id-field" className="form-label">
              PVC Number
            </Label>
            <Input
              name="pvc_number"
              id="id-field"
              className="form-control"
              placeholder="Enter PVC number"
              type="number"
              step="1"
              validate={{
                required: { value: true },
              }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.pvc_number || ""}
              invalid={formik.touched.pvc_number && formik.errors.pvc_number}
            />
            {formik.touched.pvc_number && formik.errors.pvc_number && (
              <FormFeedback>{formik.errors.pvc_number}</FormFeedback>
            )}
          </div>
        </Col>
        <Col>
          <div className="mb-3">
            <Label htmlFor="customername-field" className="form-label">
              PVC Date
            </Label>
            <Flatpickr
              name="pvc_date"
              className={`form-control ${
                formik.touched.pvc_date && formik.errors.pvc_date
                  ? "is-invalid"
                  : ""
              }`}
              id="datepicker-publish-input"
              placeholder="Select a date"
              options={{
                enableTime: false,
                altInput: true,
                altFormat: "d.m.Y",
                dateFormat: "Y-m-d",
                allowInput: true,
                disableMobile: true,
              }}
              onChange={(date) => {
                if (date && date.length > 0) {
                  const formattedDate = moment(date[0]).isValid()
                    ? moment(date[0]).format("YYYY-MM-DD")
                    : null;
                  formik.setFieldValue("pvc_date", formattedDate);
                } else {
                  formik.setFieldValue("pvc_date", null);
                }
              }}
              value={formik.values.pvc_date || ""}
              onBlur={(e) => {
                formik.setFieldTouched("pvc_date", true);
              }}
              invalid={formik.touched.pvc_date && formik.errors.pvc_date}
            />

            {formik.touched.pvc_date && formik.errors.pvc_date ? (
              <FormFeedback type="invalid">
                {formik.errors.pvc_date}
              </FormFeedback>
            ) : null}
          </div>
        </Col>
      </Row>
      <div className="mb-3">
        <div>
          <Label htmlFor="amount-field" className="form-label">
            Notary
          </Label>
          <Input
            name="notary"
            type="text"
            placeholder="Enter Notary"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notary || ""}
            invalid={
              formik.touched.notary && formik.errors.notary ? true : false
            }
          />
          {formik.touched.notary && formik.errors.notary ? (
            <FormFeedback type="invalid">{formik.errors.notary}</FormFeedback>
          ) : null}
        </div>
      </div>
      <div className="mb-3">
        <div>
          <Label htmlFor="payment-field" className="form-label">
            Notes
          </Label>

          <Input
            name="notes"
            id="notes-field"
            className="form-control"
            placeholder="Enter Notes"
            type="textarea"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notes || ""}
            invalid={formik.touched.notes && formik.errors.notes ? true : false}
          />
          {formik.touched.notes && formik.errors.notes ? (
            <FormFeedback type="invalid">{formik.errors.notes}</FormFeedback>
          ) : null}
        </div>
      </div>

      <div className="mb-3">
        <Label htmlFor="type-field" className="form-label">
          Contract Type
        </Label>
        <Input
          name="type"
          id="type-field"
          className="form-control"
          placeholder="Select Contract Type"
          type="select"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.type || ""}
          invalid={formik.touched.type && formik.errors.type ? true : false}
        >
          <option value="">Select Type</option>
          <option value="PRE-CONTRACT">Pre-Contract</option>
          <option value="CREDIT">Credit</option>
          <option value="CASH">Cash</option>
          <option value="DEVELOPER">Developer</option>
          <option value="OTHER">Other</option>
        </Input>
        <FormFeedback>{formik.errors.type}</FormFeedback>
      </div>
      {clientDetails == undefined ? (
        <div className="mb-3">
          <Label htmlFor="project-field" className="form-label">
            Select Client
          </Label>
          <Input
            name="client"
            id="client-field"
            type="select"
            className="form-select"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.client || ""}
            invalid={
              formik.touched.client && formik.errors.client ? true : false
            }
          >
            <option value="">Select a Client</option>
            {clients.map((client) => (
              <option key={client.id} value={client.id}>
                {client.name + " " + (client.surname ? client.surname : "")}
              </option>
            ))}
          </Input>

          {formik.touched.client && formik.errors.client && (
            <FormFeedback type="invalid">{formik.errors.client}</FormFeedback>
          )}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ContractTab;
